import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import emojiTranslate from '../../helpers/emojiTranslate';
import Message from './messages/Message';

class IncomeMessage extends Component {
  render() {
    const {
      avatar, message, name, surname, messageType, created_at, fullMessage, id, conversation_id,
    } = this.props;
    if (fullMessage.type == '2') {
      return (
        <div className="message-unsubscribed">
          {message}
        </div>
      );
    }
    const displayName = name || surname ? (`${name} ${surname}`).trim() : null;
    const containerClass = classNames({
      'flex-col': true,
      'area-content-message-left': true,
      'message-unsubscribed': messageType == 2,
    });
    const displayMessage = emojiTranslate(message);
    return (
      <div className={containerClass} id={`message-${conversation_id}-${id}`}>
        <div>
          <p className="area-content-message_name">
            {displayName}
            {' '}
            {created_at.getDate()}
            {'.'}
            {created_at.getMonth() + 1}
            {' '}
            {created_at.getHours() < 10 ? `0${created_at.getHours()}` : created_at.getHours()}
            {':'}
            {created_at.getMinutes() < 10 ? `0${created_at.getMinutes()}` : created_at.getMinutes()}
          </p>
        </div>
        <Message
          type={fullMessage.type}
          text={displayMessage}
          thumbnail={fullMessage.thumbnail}
          media={fullMessage.url}
          url={fullMessage.url}
          filename={fullMessage.filename}
          messageId={id}
        />
        <div className="message-user-image">
          <img src={avatar || '/images/user.png'} alt="" />
        </div>
      </div>
    );
  }
}

IncomeMessage.propTypes = {};

export default IncomeMessage;
